import React from "react";
import TextInput from "./element/TextInput";

function FormBio({ bio, updateData }) {
  function handleChange(e) {
    updateData({
      property: e.target.name,
      newValue: e.target.value,
      category: "bio",
    });
  }
  return (
    <>
      <div className="my-4 flex flex-col">
        <div className="text-base font-semibold pb-2">Bio</div>

        <TextInput
          labelText="Name:"
          inputName="name"
          inputOnChange={handleChange}
          inputValue={bio.name}
        />
        <TextInput
          labelText="Job Title:"
          inputName="jobTitle"
          inputOnChange={handleChange}
          inputValue={bio.jobTitle}
        />
      </div>
    </>
  );
}

export default FormBio;
